/**
 * Arabe — bundle VOLONTAIREMENT VIDE.
 *
 * L'arabe est pour l'instant une langue de TEST : elle sert a verifier les
 * traductions des textes de theme (champ `translations` du BO), dont les chaines
 * arabes sont nettement plus longues que les francaises — c'est exactement le cas
 * qui faisait deborder la zone avant le fix de fitTranslationToDesignedBox.
 *
 * Toutes les clefs absentes retombent sur le francais via `fallbackLocale`, donc
 * l'interface reste lisible pendant le test. Deux raisons de ne pas traduire les
 * 499 clefs ici :
 *
 *  - l'interface n'est pas adaptee au RTL (aucun `dir="rtl"`, aucun miroir des
 *    marges/positions) : une interface arabe rendue en LTR serait pire qu'une
 *    interface francaise assumee ;
 *  - les traductions d'interface sont de toute facon surchargeables PAR
 *    STOREFRONT depuis le BO (onglet Traductions, cf. fetchAndMergeTranslations),
 *    qui viendra remplir ces clefs sans toucher au front.
 *
 * Pour en faire une vraie langue de production : traduire les clefs de fr.ts,
 * retirer 'ar' de TEST_ONLY_LOCALES dans utils/i18n.ts, et faire la passe RTL.
 */
export default {} as Record<string, string>;
